import React from 'react'
import {
  BadgeStatusEntrega,
  Btn,
  Cnpj,
  CustomCard,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { connect } from 'react-redux'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  fetchEnderecamentoEntregas,
  fetchEnderecamentoEntregasAnalitico,
} from '../../../../services/api/https/deliveries/enderecamento-entregas.http'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import ModalEditEnderecoEntrega from './ModalEditEnderecoEntrega'
import { openReportInNewTab } from '../../../../services/util/report.service'
import { urlReportTagEnderecamentoEntrega } from '../../../../services/api/routes/deliveries.routes'

function EnderecamentoDasEntregas({ selectedTp, dispatch, history }) {
  // Vars
  const INIT_STATE = {
    entregas: [],
    globalFilter: '',
    entregaSelecionada: '',
    showModal: false,
  }
  // Hooks
  const [state, setState] = React.useState(INIT_STATE)
  React.useEffect(() => {
    _fetchEntregas()
  }, [selectedTp])

  // Events
  const onMenuItemClicked = (menuItem, entrega) => {
    if (menuItem === 'Editar Endereço') {
      setState({ ...state, entregaSelecionada: entrega, showModal: true })
    } else if (menuItem === 'Emitir Tag') {
      _emitirTagDaEntrega(entrega)
    }
  }

  const onBtnExportarSinteticoClicked = () => {
    const data = [
      [
        'nome_fantasia',
        'cnpj',
        'empresa',
        'identificador',
        'qte_caixas',
        'status',
        'endereco_estoque',
      ],
    ]
    state.entregas.forEach(e => {
      data.push([
        e.nomeFantasia,
        e.cnpj,
        e.empresa,
        e.identifier,
        e.qte_caixas,
        e.status,
        e.endereco_estoque,
      ])
    })
    gerarArquivoExcel('entregas_paradas_estoque', data, 'entregas_paradas_estoque.xlsx')
  }

  const onBtnExportarAnaliticoClicked = async () => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico desejado')
      dispatch(showLoadingBox('Gerando as informações analíticas', 'Aguarde . . .'))
      const entregasAnalitico = await fetchEnderecamentoEntregasAnalitico(selectedTp)

      const data = [
        [
          'nome_fantasia',
          'cnpj',
          'empresa',
          'identificador',
          'status',
          'endereco_estoque',
          'codigo_produto',
          'produto',
          'qte_total',
          'qte_falta',
          'data_importacao',
        ],
      ]
      entregasAnalitico.forEach(e => {
        data.push([
          e.nomeFantasia,
          e.cnpj,
          e.empresa,
          e.identifier,
          e.status,
          e.endereco_estoque,
          e.product_code,
          e.product,
          e.qte_total,
          e.qte_falta,
          e.data_importacao,
        ])
      })
      gerarArquivoExcel('entregas_analitico', data, 'entregas_paradas_estoque_analitico.xlsx')
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onModalClose = entregaEditada => {
    setState(prevState => {
      const index = prevState.entregas.findIndex(e => e.delivery_id === entregaEditada.delivery_id)
      if (index !== -1) {
        prevState.entregas[index] = entregaEditada
      }
      return { ...prevState, showModal: false }
    })
  }

  // Helpers
  const _getMenuItems = () => {
    return ['Editar Endereço', 'Emitir Tag']
  }

  const _fetchEntregas = async () => {
    try {
      if (selectedTp === 0) throw new Error('Selecione o Operador Logístico desejado')
      dispatch(showLoadingBox('Carregando as Entregas', 'Aguarde . . .'))
      const entregas = await fetchEnderecamentoEntregas(selectedTp)
      setState({ ...state, entregas })
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const _emitirTagDaEntrega = entrega => {
    try {
      const reportUrl = urlReportTagEnderecamentoEntrega(entrega.delivery_id)
      openReportInNewTab(reportUrl)
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    }
  }

  // Render
  return (
    <>
      <PageHeader>
        3.11 - Endereçamento das Entregas - &nbsp; <strong>Estoque</strong>
      </PageHeader>
      <div style={{ marginTop: 25 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-12">
              <Btn onClick={onBtnExportarSinteticoClicked}>Exportar - Sintético</Btn>
              <div style={{ display: 'inline', marginLeft: 16 }}>
                <Btn onClick={onBtnExportarAnaliticoClicked}>Exportar - Analítico</Btn>
              </div>
            </div>
            <div className="p-col-4">
              <CustomCard
                title={'Qte Entregas'}
                subTitle={'em estoque:'}
                valueStyle={{ fontWeight: 'bold', fontSize: 16 }}
              >
                {state.entregas.length}
              </CustomCard>
            </div>
            <div className="p-col-4">
              <CustomCard
                title={'Qte Caixas'}
                subTitle={'em estoque:'}
                valueStyle={{ fontWeight: 'bold', fontSize: 16 }}
              >
                {state.entregas.reduce((total, item) => total + item.qte_caixas, 0)}
              </CustomCard>
            </div>
            <div className="p-col-4" />

            <div className="p-col-12">
              <DataTable
                value={state.entregas}
                emptyMessage={'Não existe entrega para endereçamento'}
                globalFilter={state.globalFilter}
                header={
                  <CustomDataTableHeader
                    onChange={value => setState({ ...state, globalFilter: value })}
                  />
                }
                paginator={true}
                rows={20}
              >
                <Column field={'identifier'} header={'Identificador'} />
                <Column field={'nomeFantasia'} header={'Fantasia'} />
                <Column
                  field={'cnpj'}
                  header={'CNPJ'}
                  style={tableCellCentered(150)}
                  body={entrega => <Cnpj>{entrega.cnpj}</Cnpj>}
                />
                <Column field={'empresa'} header={'Empresa'} style={tableCellCentered(100)} />
                <Column field={'qte_caixas'} header={'Qte. Caixas'} style={tableCellCentered(90)} />
                <Column
                  field={'endereco_estoque'}
                  header={'End. Estoque'}
                  style={{ textAlign: 'center' }}
                  body={entrega => {
                    if (entrega.endereco_estoque) {
                      const enderecos = entrega.endereco_estoque.split(';')
                      return Array.isArray(enderecos) ? enderecos.join('; ') : enderecos
                    }
                    return entrega.endereco_estoque
                  }}
                />
                <Column
                  field={'status'}
                  header={'Status'}
                  style={tableCellCentered()}
                  body={entrega => <BadgeStatusEntrega status={entrega.status} />}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={entrega => (
                    <ThreeDots
                      items={_getMenuItems()}
                      onClick={item => onMenuItemClicked(item, entrega)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
              </DataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalEditEnderecoEntrega
        visible={state.showModal}
        onClose={onModalClose}
        entrega={state.entregaSelecionada}
      />
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(EnderecamentoDasEntregas))
